Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRowCell = void 0;

var core_1 = require("@emotion/core");

var core_2 = require("@wheelroom/core");

var wheel_topic_1 = require("@wheelroom/wheel-topic");

exports.TableRowCell = function (props) {
  if (!props.topic && !props.data) {
    return null;
  }

  var dataCellStyle = props.wheel.style.td;

  if (!(dataCellStyle.ncss.w || dataCellStyle.ncss.width)) {
    dataCellStyle.ncss.w = props.dataCellWidth;
  }

  return core_1.jsx(core_2.Td, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: dataCellStyle
    })
  }, core_1.jsx(wheel_topic_1.Topic, {
    data: props.data.topic,
    topic: props.topic,
    topicOptions: props.topicOptions,
    useHeadingElement: "p",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.topic
    })
  }));
};